import React, { useContext } from 'react';
import { FormProvider } from 'react-hook-form';
import { FormStateContext } from './context/FormStateContext';

/**
 * @typedef {object} DialogFormWrapperProps
 * @property {(data?: Object) => void | Promise<void>} handleConfirm
 * @property {React.ReactNode} children
 */

/**
 * @param {DialogFormWrapperProps} props
 */
const DialogFormWrapper = props => {
  const { handleConfirm, children } = props;
  const { form, onError } = useContext(FormStateContext);

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleConfirm, onError)}>{children}</form>
    </FormProvider>
  );
};

export default DialogFormWrapper;
